import * as React from 'react';
import * as _ from 'lodash';
import SearchBar from './../SearchBar';
import { GlobalHeaderButtons } from './../PageLayout/GlobalHeaderButtons';
export default function () {
    function onClick1(level, taxRegion, filterGroup) {
        this.showDropDown(true);
    }
    function onBlur2(level, taxRegion, filterGroup) {
        this.showDropDown(false);
    }
    function onClick3(level, taxRegion, filterGroup, group, groupIndex) {
        this.selectGroup(group);
    }
    function repeatGroup4(level, taxRegion, filterGroup, group, groupIndex) {
        return React.createElement('li', {
            'className': 'select3-dropdown__list-item',
            'key': group,
            'onClick': onClick3.bind(this, level, taxRegion, filterGroup, group, groupIndex)
        }, React.createElement('span', { 'className': 'select3-dropdown__list-item-text' }, group));
    }
    function scopeLevelTaxRegionFilterGroup5() {
        var level = this.props.level;
        var taxRegion = this.props.taxRegion;
        var filterGroup = this.props.filterGroup.toJS();
        return React.createElement('div', { 'className': 'app-header app-header-adj' }, React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('div', { 'className': 'select3 select3--active' }, React.createElement('div', { 'className': 'select3-value' }, React.createElement('span', { 'className': 'select3-value__text' }, filterGroup.name, ' tax profiles'), React.createElement('button', {
            'className': 'select3-value__button',
            'onClick': onClick1.bind(this, level, taxRegion, filterGroup)
        })), this.state.dropDownVisible ? React.createElement('span', {
            'className': 'select3-dropdown',
            'tabIndex': '1',
            'onBlur': onBlur2.bind(this, level, taxRegion, filterGroup),
            'ref': ref => this.dropDownRef = ref,
            'key': '766'
        }, React.createElement.apply(this, [
            'ul',
            { 'className': 'select3-dropdown__list' },
            _.map(taxRegion.allGroups, repeatGroup4.bind(this, level, taxRegion, filterGroup))
        ])) : null))));
    }
    return scopeLevelTaxRegionFilterGroup5.apply(this, []);
}